module.exports = __webpack_public_path__ + "img/trail_event.8554f72.png";